<template lang="pug">
.container
  .main_video
    .video_wrapper#video_wrapper
      .player#player
    .main_txt1.main_txt
      .in
        img(:src='require("../../assets/images/main_logo.png")' alt='main logo')
        h2 Future of 
          span Smart Brewery 
        | Platform
    .main_txt2.main_txt
      p 본영상은 최종 출시전 개발모델로 실제 판매모델의 디자인과는 일부 차이가 있습니다.
  section.main01
    .in
      h2(data-aos="fade-down")
        | 맥주를 가장 
        span.bold 맛있게
        |  즐길 수 있는 방법.
      .m01_lt.list
        .img(data-aos="fade-right")
        .txt
          p Smart Brewery Platform
          h3(data-aos="fade-left" data-aos-delay="100")
            | 그 방법은
            span.bold
              |  바로 만든 신선한 맥주를
              br
              | 그 자리에서 즐기는 것
            | 입니다.
      .m01_rg.list
        .txt(data-aos='fade-right')
          p INTHEKEG
          h3(data-aos='fade-right' data-aos-delay='100')
            | INTHEKEG는 
            span.bold 현장에서 발효 및 숙성
            | 하여
            br
            | 가장 신선한 맥주를
            span.bold  최적의 온도로 제공
            | 합니다.
        .img(data-aos='fade-left')
      .list
        .img(data-aos='fade-up')
        .txt
          h3(data-aos='fade-down' data-aos-delay='100') INTHEKEG가 있다면
            span.bold  누구라도 쉽게 신선한 맥주를 만들 수 있습니다.
          p(data-aos='fade-down' data-aos-delay='120')
            | INTHEKEG가 있으면 기존 맥주 제조 공정에 비해 아주 작은 공간과 자본만 있어도 브루어리가 될 수 있습니다.
            br
            | INTHEKEG로 맥주를 만드는데 맥주에 대한 지식이나 맥주 제조 경험이 필요하지 않습니다.
  section.main02
    h2.tit SMART BREWERY
    .list.m02_lt
      .in
        .img(data-aos='fade-right')
        .txt(data-aos='fade-left')
          h3 INTHEKEG
          p
            | INTHEKEG는 시간, 인력, 비용을 최소화하며 효모가 살아있는 신선한 맥주를 
            br
            | 다양하게 제조할 수 있는 전세계 유일한 A.I. 기반의 수제맥주 제조 시스템입니다.
          .v_btn
            a(@click='$_goTo({name: "smart"})')
              span VIEW MORE
                img(:src='require("../../assets/images/v_arr.png")' alt='->')
    .list.m02_rg
      .in
        .txt(data-aos='fade-right')
          h3 SMARTKEG
          p
            | SMARTKEG는 맥주의 원료인 맥즙과 Yeast 캡슐이 장착된 KEG입니다. 
            br
            | 특허 받은 구조를 기반으로 INTHEKEG에 다양한 주류 및 음료를 
            br
            | 생산/유통/판매하기 위한 최적의 제품 패키지 방식입니다.
          .v_btn
            a(@click='goTo("smartkeg")')
              span VIEW MORE
                img(:src='require("../../assets/images/v_arr.png")' alt='->')
        .img(data-aos='fade-left')
  section.main03
    .in
      h2.tit(data-aos='fade-down') Beer Care System
      p(data-aos='fade-down' data-aos-delay='100')
        | Beer Care System은 Smart Brewery Platform을 구성하는 핵심 Software로 
        br
        | 기기 제어 및 모니터링 뿐만 아니라 모든 이벤트를 저장/분석하여 
        span 플랫폼 사용자가 필요로 하는 정보를 실시간으로 
        | 제공합니다.
      .cont
        div
          .lt(data-aos='fade-right')
            img(:src='require("../../assets/images/main0301_bg.png")' alt='background')
            img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/main0301.png' alt='itk')
            p 상태/가동 데이터
          .md(data-aos='flip-left' data-aos-delay='500')
            ul
              li(data-aos='fade-right' data-aos-delay='150') 기기 모니터링
              li(data-aos='fade-left' data-aos-delay='250') 맥주 제조 상태 관리
              li(data-aos='fade-right' data-aos-delay='350') 맥주 레시피 관리
              li(data-aos='fade-left' data-aos-delay='450') 기기/회원 관리
              li(data-aos='fade-right' data-aos-delay='550') 서비스 통계
          .rg(data-aos='fade-left' data-aos-delay='300')
            img(:src='require("../../assets/images/main0302_bg.png")' alt='background')
            img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/main0302.png' alt='itk')
            p 모니터링 푸시 알림
      .v_btn
        a(@click='goTo("BeerCareSystem")')
          span VIEW MORE
            img(:src='require("../../assets/images/v_arr.png")' alt='->')
  section.main04
    .in
      h2.tit NEWS
      swiper.swiper(:options='swiperOption' :breakpoints='swiperOption.breakpoints')
        swiper-slide(v-for="i in resData" :key="i.idx")
          p.cate 보도자료
          h3
            a(@click='$_goTo({name: "detail-news", params: {id: i.idx}})') {{i.title}}
          p.cont 
            a(@click='$_goTo({name: "detail-news", params: {id: i.idx}})' v-html="i.content")
          p.date {{i.date}}
          .p_wrap
            .p_btn
              a(@click='$_goTo({name: "detail-news", params: {id: i.idx}})')
      .v_btn
        a(@click='$_goTo({name: "news"})')
          span VIEW MORE
            img(:src='require("../../assets/images/v_arr.png")' alt='->')
  section.main05
    .in
      .lt.board.lt_b(data-aos='fade-down')
        div
          h2.tit 설치매장
          p INTHEKEG가 설치되어 있는 매장을 확인해보세요.
          .v_btn
            a(@click='$_goTo({name: "store"})')
              span 설치 매장 찾기
                img(:src='require("../../assets/images/v_arr.png")' alt='->')
      .rg.board.rg_b(data-aos='fade-up')
        div
          h2.tit CONTACT
          p 문의 사항에 대해 안내해드립니다.
          .v_btn
            a(@click='$_goTo({name: "contact"})')
              span 문의 바로가기
                img(:src='require("../../assets/images/v_arr.png")' alt='->')
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      ytp_style: {
        width: '',
        marginLeft: '',
      },
      videoState: -1,
      player: null,
      resData: [],
      swiperOption: {
        spaceBetween: 40,
        // slidesPerView: 3,
        effect: 'slide',
        loop: true,
        breakpoints: {
          1320: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true,
          },
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          // NOTE: false로 설정하면 스와이프 후 자동 재생이 비활성화 되지 않음
        },
      },
    };
  },
  computed: {
    ...mapGetters(['lan', 'popup']),
  },
  methods: {
    ...mapActions([
      'getPopup',
      'delPopup',
      'neverTimeReset',
      'editPopup',
      'comparePopup',
    ]),
    async getNews() {
      await this.$_axios('GET', 'board/news/slide', { nation: this.lan }).then(
        res => {
          this.resData = res.data.res;
        },
      );
    },
    goTo(place) {
      this.$_goTo({ name: 'smart', params: { place: place } });
    },
    async getPopupData() {
      await this.$_axios('GET', 'board/popup')
        .then(this.getPopup)
        .then(this.delPopup)
        .then(this.comparePopup)
        .then(res => {
          // NOTE: 팝업 데이터 가져옴 > 기간 만료된 팝업 삭제 > 수정된 팝업 데이터 업데이트
          if (res.data.res.length !== 0) {
            this.neverTimeChecker();
          }
        });
    },
    neverTimeChecker() {
      this.popup.forEach((e, i) => {
        if (e.neverTime !== '') {
          let now = new Date();
          if (now <= new Date(e.neverTime)) {
            // NOTE: 24시간 보지 않기 해당 중
            let payload = {
              idx: e.idx,
              neverShow: false,
            };
            this.editPopup(payload);
          } else {
            this.neverTimeReset(i);
          }
        }
      });
      this.$emit('get-modal', true);
    },
    initYoutube() {
      if (typeof YT !== undefined) {
        const $_self = this;
        this.player = new YT.Player('player', {
          // width: '100%',
          height: '100%',
          videoId: '9GcwPfRZthE',
          host: 'https://www.youtube.com',
          playerVars: {
            playlist: '9GcwPfRZthE',
            mute: 1,
            autohide: 1,
            loop: 1,
            autoplay: 1,
            rel: 0,
            controls: 0,
            fs: 0,
            modestbranding: 1,
            playsinline: 1,
            origin: window.location.href,
          },
          events: {
            onReady: $_self.onPlayerReady,
            onStateChange: $_self.onPlayerStateChange,
          },
        });
      }
    },
    onPlayerReady(evt) {
      evt.target.playVideo();
    },
    onPlayerStateChange(evt) {
      this.videoState = evt.data;
      if (evt.data === YT.PlayerState.ENDED) {
        evt.target.playVideo();
      }
    },
    onResize() {
      let windowWidth = window.outerWidth;
      if (windowWidth <= 768) {
        const abundance = 0.3;
        let playerHeight = document.getElementById('player').clientHeight;
        let elHeight = playerHeight * 0.63;
        let ab = Math.ceil(elHeight * abundance);
        let width = (playerHeight + ab + ab) * (16 / 9) + 400;
        let marginLeftValue = -(width - windowWidth) / 2;

        document.getElementById('player').style.width = width + 'px';
        document.getElementById('player').style.marginLeft =
          marginLeftValue + 'px';

        // this.ytp_style.width = width + 'px';
        // this.ytp_style.marginLeft = marginLeftValue + 'px';
      } else {
        document.getElementById('player').style.width = '100%';
        document.getElementById('player').style.marginLeft = '0px';
      }
    },
  },
  async mounted() {
    this.getNews();
    await this.getPopupData();

    // window.onYouTubeIframeAPIReady = () => {
    //   this.initYoutube();
    // };
    this.initYoutube();

    this.onResize();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>
<style>
@import '../../assets/css/slide.css';
@import '../../assets/css/swiper.css';

/* Main Youtube */
.container {
  width: 100%;
  margin: 0 auto;
}
.main_video {
  z-index: -1;
}
.main04 .swiper-wrapper .swiper-slide {
  background-color: #fff;
}
.new_list h3 a {
  word-break: break-all;
  font-size: 22px;
  color: #333;
  font-weight: 500;
  transition: 0.3s;
}
.new_list h3 a:hover {
  color: #ffa943;
  transition: 0.3s;
}
.new_list h3 {
  padding: 30px 0 20px;
}
.video_wrapper {
  background-image: none;
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video_wrapper iframe {
  animation: fadein 3s;
  -webkit-animation: fadein 4s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  /* Safari and Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 0;
  }
}
.main_video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 947px;
  height: auto;
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/vd_bg.jpg')
    no-repeat center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
@media (max-width: 768px) {
  .main_video {
    height: auto;
  }
  .video_wrapper {
    padding-top: 300px !important;
  }
}
@media (max-width: 1024px) {
  .main_video {
    margin-top: 60px;
  }
}
</style>
